export const AVAILABLE = "available";
export const RESERVED = "reserved";
export const SOLD = "sold";
export const UNDER_CONTRACT = "under_contract";
